import { OptionItem, GroupOption } from '../types'

export function isGroupOption<T>(option: OptionItem<T>): option is GroupOption<T> {
  return 'optionGroupLabel' in option
}
